import { invalidateItemQueries } from '@/shared/api/invalidate-item-queries';
import { trpc } from '@/shared/api/trpc';

export const useUpdateSuppliers = () => {
  const utils = trpc.useUtils();
  return trpc.operations.updateSuppliers.useMutation({
    onSettled: () => {
      invalidateItemQueries(utils);
      utils.operations.tourOperatorAssignments.invalidate();
    },
  });
};
